import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"delete\"><title>delete</title><g id=\"delete__visibility\"><g id=\"delete_delete-2\" data-name=\"delete\"><path d=\"M19,3H14V1H7V3H2V7H4.08L6,20h8.85L16.92,7H19ZM8,2h5V3H8Zm6,17H6.85L5.09,7H15.91ZM18,6H3V4H18Z\" /><rect x=\"8\" y=\"8.5\" width=\"1\" height=\"8.5\" /><rect x=\"12\" y=\"8.5\" width=\"1\" height=\"8.5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/delete.svg
// module id = eXS7
// module chunks = 4